<template>
    <div class="vlh-card">
        <div class="vlh-card-header" :style="{ 'background-color': laneColor }"
             style="color: white; text-align: left;">
            <p style="padding-left: 15px; padding-right: 15px">
                {{ state.spot }}
                <button class="vlh-light-btn" :style="{ 'background-color': laneColor }"
                        @click="OpenCreatePlanningEmployeeThresholdModal($event, state.spotId)">
                    <i class="fas fa-plus-circle"></i>
                </button>
            </p>
        </div>
        <div class="vlh-card-body">
            <div class="indicator-header">{{ indicatorHeader }}</div>
            <table class="vlh-card-table vlh-light-gray">
                <thead style="background: var(--contrast-3); padding-right: 15px">
                <tr>
                    <th class="vlh-plr vlh-table-header center">MA</th>
                    <th class="vlh-table-header right">{{ $t('global.general.from') }}</th>
                    <th class="vlh-table-header middle">-</th>
                    <th class="vlh-table-header left">{{ $t('global.general.to') }}</th>
                    <th class="vlh-table-header center"></th>
                    <th class="vlh-table-header center"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(row, index) in rows" :key="index"
                    :style="{ background: `var(--contrast-${index % 2})` }">
                    <td v-if="index === 0 && parseFloat(row.entries[4].label) > 0" class="vlh-card-cell center vlh-plr">0</td>
                    <td v-if="index !== 0 && index <= rows.length - 1 && parseFloat(row.entries[4].label) > 0"
                        class="vlh-card-cell center vlh-plr">
                        {{ rows[index - 1].entries[5].label }}
                    </td>

                    <td v-if="index === 0 && parseFloat(row.entries[4].label) > 0" class="vlh-card-cell right">0</td>
                    <td v-if="index !== 0 && index <= rows.length - 1 && parseFloat(row.entries[4].label) > 0"
                        class="vlh-card-cell right">
                        {{ formatValue(rows[index - 1].entries[4].label) }}
                    </td>

                    <td v-if="parseFloat(row.entries[4].label) > 0" class="vlh-card-cell middle">-</td>

                    <td v-if="index <= rows.length - 1 && parseFloat(row.entries[4].label) > 0"
                        class="vlh-card-cell left">
                        {{
                            formatValue(row.entries[4].label)
                        }}
                    </td>

                    <td v-if="index === 0 && parseFloat(row.entries[4].label) > 0"></td>
                    <td v-if="index === 0 && parseFloat(row.entries[4].label) > 0"></td>
                    <td v-if="index !== 0 && parseFloat(row.entries[4].label) > 0" class="vlh-card-cell">
                        <button class="vlh-dark-btn first"
                                @click="OpenEditPlanningEmployeeThresholdModal($event, rows[index - 1].data)">
                            <i class="fa fa-pen-circle vlh-dark-btn"></i>
                        </button>
                    </td>
                    <td v-if="index !== 0 && parseFloat(row.entries[4].label) > 0" class="vlh-card-cell">
                        <button class="vlh-dark-btn last"
                                @click="OpenDeletePlanningEmployeeThresholdModal($event, rows[index - 1].data)">
                            <i class="fa fa-circle-trash vlh-dark-btn"></i>
                        </button>
                    </td>
                </tr>
                <tr :style="{ background: `var(--contrast-${rows.length % 2})` }">
                    <td class="vlh-card-cell center vlh-plr">{{ rows[rows.length - 1].entries[5].label }}</td>
                    <td class="vlh-card-cell right">{{ formatValue(rows[rows.length - 1].entries[4].label) }}</td>
                    <td class="vlh-card-cell middle">-</td>
                    <td class="vlh-card-cell"></td>
                    <td class="vlh-card-cell">
                        <button class="vlh-dark-btn first"
                                @click="OpenEditPlanningEmployeeThresholdModal($event, rows[rows.length - 1].data)">
                            <i class="fa fa-pen-circle vlh-dark-btn"></i>
                        </button>
                    </td>
                    <td class="vlh-card-cell">
                        <button class="vlh-dark-btn last"
                                @click="OpenDeletePlanningEmployeeThresholdModal($event, rows[rows.length - 1].data)">
                            <i class="fa fa-circle-trash vlh-dark-btn"></i>
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

export default {
    name: "card",
    components: {},
    data() {
        return {
            headerMap: [],
            data: [],
            dataSum: [],
            filters: [],
            sort: { column: { label: '' }, descending: false },
            collapsedStates: {},
            hideHeader: false,
            pageCurrent: 0,
            rowsSelected: [],
            headerStyles: {},
            compact: false,
            inputFocusState: {},
            heightRow: 40,
            rowStyles: {},
            coloredHeader: false,
            collapsedWidth: '25px',
        }
    },
    props: {
        state: Object,
        laneColor: String,
        filterCheckState: Object,
        filterState: Object,
        pageState: Object,
        rowSelect: Boolean,
        OpenCreatePlanningEmployeeThresholdModal: {
            type: Function,
            required: true
        },
        OpenEditPlanningEmployeeThresholdModal: {
            type: Function,
            required: true
        },
        OpenDeletePlanningEmployeeThresholdModal: {
            type: Function,
            required: true
        }

    },

    watch: {
        state: {
            immediate: true,
            handler(newVal, oldVal) {
                for (let x in newVal) this[x] = newVal[x];
                let sortColumn = Object.values(this.headerMap).find(h => h.label === this.sort.column.label);
                if (sortColumn) {
                    if (sortColumn.sort !== true) this.data.sort(sortColumn.sort);
                    else this.data.sort((a, b) => ( sortColumn.DisplayLabel(a) > sortColumn.DisplayLabel(b) ? -1 : 1 ));
                    if (!this.sort.descending) this.data.reverse();
                }
            }
        },
        filterState: {
            immediate: true,
            handler(newVal, oldVal) {
                this.filters = newVal;
            }
        },
    },
    computed: {
        indicatorHeader(){
            console.log(this.rows[0].entries[0].label)
            console.log(this.rows[0].entries[3].label)
            let h = this.rows[0].entries[0].label;
            h += this.rows[0].entries[3].label? ' / ' : ''
            h += this.rows[0].entries[3].label? this.rows[0].entries[3].label : '';
            return h;
        },
        header() {
            let view = this;
            let entries = [];
            Object.values(this.headerMap).filter(e => typeof e.collapsed === 'boolean').forEach(e => {
                if (e.collapsed) {
                    if (!e.widthActual) e.widthActual = e.width;
                    if (e.width) e.widthActual = '';
                    e.width = view.collapsedWidth;
                    if (!e.stylesEntryActual) e.stylesEntryActual = e.stylesEntry;
                    if (!e.stylesEntryActual) e.stylesEntryActual = {};
                    e.stylesEntry = { background: 'var(--contrast-1)', opacity: '.7' };
                } else {
                    e.stylesEntry = e.stylesEntryActual;
                }
                e.componentTypeColumn = 'buttonc';
                let entry = e;
                let icon = e.collapsed ? e.collapsedIcon ? e.collapsedIcon : 'fa-angle-right' : e.icon != undefined ? '' : 'fa-angle-left';
                let style = e.collapsed ?
                    {
                        'font-size': '14px',
                        width: '20px',
                        height: '20px',
                        top: '0',
                        right: '0',
                        left: '0',
                        bottom: '0',
                        margin: 'auto',
                        'position': 'absolute'
                    } : e.icon != undefined ?
                        { 'visibility': 'hidden !important' } : e.align == "right" ?
                            {
                                'font-size': '14px',
                                width: '20px',
                                height: '20px',
                                top: '0',
                                bottom: '0',
                                left: '-8px',
                                margin: 'auto',
                                'position': 'absolute',
                                transform: 'scale(0.8)'
                            } :
                            {
                                'font-size': '14px',
                                width: '20px',
                                height: '20px',
                                top: '0',
                                bottom: '0',
                                right: '0px',
                                margin: 'auto',
                                'position': 'absolute',
                                transform: 'scale(0.8)'
                            };
                e.componentPropContainer = { type: 'icon-overlay', styleButton: style, icon: icon };
                e.customEvents = {
                    click: () => {
                        if (entry.collapsed === false) {
                            entry.collapsed = true;
                            entry.width = view.collapsedWidth;
                        } else if (entry.collapsed === true) {
                            entry.collapsed = false;
                            entry.width = entry.widthActual === '' ? undefined : entry.widthActual;
                        }
                    },
                }
            });
            for (let x in this.headerMap) {
                let entry = this.headerMap[x];
                if (!entry.hidden) {
                    let label = entry.label;
                    if (label === undefined && entry.key) {
                        let temp = '';
                        entry.key.split('_').filter(l => l.length > 0).forEach(l => temp += l[0].toUpperCase() + l.substr(1) + ' ');
                        label = temp;
                        temp = '';
                        label.split('-').filter(l => l.length > 0).forEach(l => temp += l[0].toUpperCase() + l.substr(1) + ' ');
                        label = temp;
                        temp = '';
                        label.split(/(?=[A-Z])/).filter(l => l.length > 0).forEach(l => temp += ' ' + l);
                        label = temp;
                        label = label.replace(/\s\s+/g, ' ').trimRight();
                    }
                    let width = entry.width;
                    if (!width) {
                        let totalPercent = 0;
                        let totalPixel = 0;
                        let assignedPercent = 0;
                        let assignedPixel = 0;
                        Object.values(this.headerMap).filter(h => h.width && h.width.indexOf('%') >= 0 && !isNaN(parseInt(h.width.substr(0, h.width.length - 1)))).forEach(h => {
                            assignedPercent++;
                            totalPercent += parseInt(h.width.substr(0, h.width.length - 1));
                        });
                        Object.values(this.headerMap).filter(h => h.width && h.width.indexOf('px') >= 0 && !isNaN(parseInt(h.width.substr(0, h.width.length - 2)))).forEach(h => {
                            assignedPixel++;
                            totalPixel += parseInt(h.width.substr(0, h.width.length - 2));
                        });
                        let remaining = 100 - totalPercent;
                        width = 'calc(' + ( remaining / ( Object.values(this.headerMap).length - assignedPercent ) ) + '% - ' + ( totalPixel / ( Object.values(this.headerMap).length - assignedPixel ) ) + 'px)';
                    }
                    let entryTemp = {
                        label: label, width: width, map: entry,
                        componentTypeColumn: entry.componentTypeColumn,
                        componentState: entry.componentState,
                    };
                    entries.push(entryTemp);
                }
            }
            return entries;
        },
        rows() {
            let view = this;
            view.collapsedStates = {};
            let sortColumn = Object.values(this.headerMap).find(h => h.label === view.sort.column.label);
            if (sortColumn) {
                if (sortColumn.sort !== true) view.data.sort(sortColumn.sort);
                else view.data.sort((a, b) => ( sortColumn.DisplayLabel(a) > sortColumn.DisplayLabel(b) ? -1 : 1 ));
                if (!view.sort.descending) view.data.reverse();
            }

            let rowsTemp = [];
            let filteredData = this.filters && this.filterCheckState ? this.data.filter(d => {
                let passed = true;
                for (let x in view.filterCheckState) {
                    let filter = view.filterCheckState[x];
                    if (!filter.filterCheck(d)) passed = false;
                }
                return passed;
            }) : this.data.slice();
            if (this.pageState) {
                let start = this.pageState.pageCurrent * this.pageState.pageLength;
                let end = ( this.pageState.pageCurrent + 1 ) * this.pageState.pageLength;
                if (filteredData.length > this.pageState.pageLength) {
                    filteredData = filteredData.slice(start, end < filteredData.length ? end : filteredData.length);
                }
            }
            for (let x in filteredData) {
                let rowItem = filteredData[x];
                view.collapsedStates[x] = true;
                let entries = [];
                for (let y in this.headerMap) {
                    let header = this.headerMap[y];

                    if (!header.hidden) {
                        let entry = {
                            label: header.key && rowItem.displayLabel && rowItem.displayLabel[header.key] ? rowItem.displayLabel[header.key] : header.DisplayLabel ? header.DisplayLabel(rowItem) : '',
                            buttons: header.key && rowItem.buttons && rowItem.buttons[header.key] ? rowItem.buttons[header.key] : header.buttons,
                            OnChange: header.key && rowItem.OnChange && rowItem.OnChange.hasOwnProperty(header.key) ? rowItem.OnChange[header.key] : header.OnChange,
                            dropdown: header.key && rowItem.dropdown && rowItem.dropdown.hasOwnProperty(header.key) ? rowItem.dropdown[header.key] : header.dropdown,
                            clickOptions: header.key && rowItem.clickOptions && rowItem.clickOptions.hasOwnProperty(header.key) ? rowItem.clickOptions[header.key] : header.clickOptions,
                            disabled: header.key && rowItem.disabled && rowItem.disabled.hasOwnProperty(header.key) ? rowItem.disabled[header.key] : header.DisabledCheck ? header.DisabledCheck(rowItem) : false,
                            componentTypeRow: header.key && rowItem.componentTypeRow && rowItem.componentTypeRow.hasOwnProperty(header.key) ? rowItem.componentTypeRow[header.key] : header.componentTypeRow,
                            dropdownActive: false,
                            headerKey: header.key,
                            item: rowItem,
                            align: rowItem.align ? rowItem.align : header.align,
                            map: header,
                            data: rowItem,
                        };
                        if (entry.componentTypeRow) entry.componentStateBuilder = header.key && rowItem.componentStateBuilder && rowItem.componentStateBuilder.hasOwnProperty(header.key) ? rowItem.componentStateBuilder[header.key] : header.componentStateBuilder ? header.componentStateBuilder : null;
                        if (!entry.componentStateBuilder) entry.componentTypeRow = null;
                        if (entry.componentStateBuilder) entry.component = entry.componentStateBuilder(rowItem, entry);
                        if (header.GetEntryDropdown) {
                            entry.dropdown = header.GetEntryDropdown(entry);
                            entry.dropdown.OnToggle = (el, toggle) => {
                                if (!toggle) {
                                    entry.dropdownActive = false;
                                    view.$forceUpdate();
                                }
                            }
                        }
                        if (header.entryTooltip) {
                            entry.entryTooltip = header.entryTooltip(rowItem)
                        }
                        entries.push(entry);
                    }
                }
                rowsTemp.push({ entries: entries, data: filteredData[x] });
            }
            let subTemp = rowsTemp.filter(r => r.data.subEntries);
            subTemp.forEach(row => {
                row.subEntries = [];
                for (let x in row.data.subEntries) {
                    let rowItem = row.data.subEntries[x];
                    let entries = [];
                    for (let y in view.headerMap) {
                        let header = view.headerMap[y];
                        if (!header.hidden) {
                            let subEntry = {
                                label: header.key && rowItem.displayLabel && rowItem.displayLabel[header.key] ? rowItem.displayLabel[header.key] : header.DisplayLabel ? header.DisplayLabel(rowItem) : '',
                                buttons: header.key && rowItem.buttons && rowItem.buttons[header.key] ? rowItem.buttons[header.key] : header.buttons,
                                OnChange: header.key && rowItem.OnChange && rowItem.OnChange.hasOwnProperty(header.key) ? rowItem.OnChange[header.key] : header.OnChange,
                                dropdown: header.key && rowItem.dropdown && rowItem.dropdown.hasOwnProperty(header.key) ? rowItem.dropdown[header.key] : header.dropdown,
                                clickOptions: header.key && rowItem.clickOptions && rowItem.clickOptions.hasOwnProperty(header.key) ? rowItem.clickOptions[header.key] : header.clickOptions,
                                disabled: header.key && rowItem.disabled && rowItem.disabled.hasOwnProperty(header.key) ? rowItem.disabled[header.key] : header.DisabledCheck ? header.DisabledCheck(rowItem) : false,
                                componentTypeRow: header.key && rowItem.componentTypeRow && rowItem.componentTypeRow.hasOwnProperty(header.key) ? rowItem.componentTypeRow[header.key] : header.componentTypeRow,
                                componentStateBuilder: header.key && rowItem.componentStateBuilder && rowItem.componentStateBuilder.hasOwnProperty(header.key) ? rowItem.componentStateBuilder[header.key] : header.componentStateBuilder,
                                dropdownActive: false,
                                headerKey: header.key,
                                item: rowItem,
                                align: rowItem.align ? rowItem.align : header.align,
                                map: header,
                                data: rowItem,
                            };

                            if (subEntry.componentTypeRow) subEntry.componentStateBuilder = header.key && rowItem.componentStateBuilder && rowItem.componentStateBuilder.hasOwnProperty(header.key) ? rowItem.componentStateBuilder[header.key] : header.componentStateBuilder ? header.componentStateBuilder : null;
                            if (!subEntry.componentStateBuilder) subEntry.componentTypeRow = null;
                            if (subEntry.componentStateBuilder) subEntry.component = subEntry.componentStateBuilder(rowItem, subEntry);
                            entries.push(subEntry);
                        }
                    }
                    row.subEntries.push({ entries: entries, data: rowItem });
                }
            });
            return rowsTemp;
        },
        rowsSum() {
            let view = this;

            let rowsTemp = [];

            for (let x in this.dataSum) {
                let rowItem = this.dataSum[x];
                let entries = [];
                for (let y in this.headerMap) {
                    let map = this.headerMap[y];
                    if (!map.hidden) {
                        let label = '';
                        if (map.key && rowItem[map.key]) {
                            label = rowItem[map.key].label;
                        }
                        let align = '';
                        if (map.key && rowItem[map.key]) {
                            align = rowItem[map.key].align;
                        }
                        let OnChange = null;
                        if (map.key && rowItem[map.key]) {
                            OnChange = rowItem[map.key].OnChange;
                        }
                        let tooltip = false;
                        if (map.key && rowItem[map.key]) {
                            tooltip = rowItem[map.key].tooltip;
                        }
                        entries.push({
                            label: label,
                            map: map,
                            item: rowItem,
                            data: rowItem,
                            align: align,
                            OnChange: OnChange,
                            tooltip: tooltip
                        });
                    }
                }
                rowsTemp.push({ entries: entries, data: rowItem });
            }
            return rowsTemp;
        }
    },
    methods: {
        formatValue(value){
            let v = Math.max(0, parseFloat(value));
            if(v === 0 || v % 1 === 0){
                return v.toFixed(0);
            }
            return v.toFixed(1);
        }
    },
}
</script>

<style scoped>
div {
    font-family: DistrictPro;
}

p {
    font-family: DistrictPro;
    margin: 0;
}

th {
    font-family: DistrictPro;
}

td {
    font-family: DistrictPro;
}

.vlh-card {
    margin: 24px 0px 24px 24px;
    background: var(--bg);
    height: max-content;
    padding-bottom: 10px;
}

.vlh-light-btn {
    border: 0;
    color: white;
    cursor: pointer;
    float: right;
}

.vlh-light-btn:hover {
    background-color: var(--bg);
    color: black;
}

.vlh-dark-btn {
    border: 0;
    color: var(--col-label-default);
    cursor: pointer;
    float: right;
    background: none;
    text-align: center;
}

.vlh-dark-btn.first {
    margin-left: 16px;
}

.vlh-dark-btn.last {
    margin-right: 8px;
}

.vlh-dark-btn:hover {
    color: var(--bg) !important;
    cursor: pointer !important;
}

.vlh-card-body {
    color: var(--col-label-default);
    padding: 10px;
}

.indicator-header{
    font-size: 12px;
    text-align: left;
    padding: 4px 0 6px 6px;
}

.vlh-card-table {
    padding: 5px;
    margin: 5px;
}

.vlh-card-header {
    text-align: left;
    font-size: 16px;
    font-weight: 900;
    padding: 8px 0 8px 0;
}

.vlh-card-cell {
    padding: 4px 4px 2px 4px;
    font-size: 14px;
}

.vlh-card-cell.center {
    text-align: center;
}

.vlh-card-cell.right {
    text-align: right;
}

.vlh-card-cell.left {
    text-align: left;
}

.vlh-table-header{
    font-size: 14px;
    font-weight: 600;
    padding: 4px 4px 2px 4px;
}

.vlh-table-header.left {
    text-align: left;
}

.vlh-table-header.center {
    text-align: center;
}

.vlh-table-header.right {
    text-align: right;
}

.vlh-plr {
    padding-left: 12px;
    padding-right: 24px;
}
</style>
